import { StrapiImageFormat, StrapiImageFormats } from "./types";

/** Порядок перебора копий Strapi — от мелкой к крупной. */
const FORMAT_ORDER: (keyof StrapiImageFormats)[] = ["thumbnail", "small", "medium", "large"];

/**
 * Выбирает копию картинки Strapi, ширины которой хватает для отрисовки.
 *
 * Strapi при загрузке генерит уменьшенные копии (`formats`), но во фронт до сих пор
 * шёл оригинал: у аватаров авторов это доходило до 2.5 МБ на картинку 104×104.
 * Берём первую копию не уже требуемой ширины; если подходящей нет (копии не
 * сгенерились или все мельче) — возвращаем оригинал, поведение как раньше.
 *
 * @param formats поле `formats` из Strapi (JSON-скаляр, может быть пустым)
 * @param url     URL оригинала — фолбэк
 * @param minWidth минимальная нужная ширина в px (обычно размер бокса × 2 под retina)
 */
export const pickImageByWidth = (
  formats: StrapiImageFormats | null | undefined,
  url: string,
  minWidth: number,
): string => {
  if (!formats) {
    return url;
  }

  const suitable = FORMAT_ORDER
    .map((key): StrapiImageFormat | undefined =>
      formats[key])
    .find((format) =>
      !!format?.url && (format.width ?? 0) >= minWidth);

  return suitable?.url ?? url;
};
